import { COMPANY_PROMOTIONS_ACTIONS } from './action';

const initialState = {
  // Promotions list
  promotions: [],
  promotionsLoading: false,
  promotionsError: null,
  
  // Single promotion
  currentPromotion: null,
  promotionLoading: false,
  promotionError: null,
  
  // Create/Update/Delete
  createLoading: false,
  createError: null,
  updateLoading: false,
  updateError: null,
  deleteLoading: false,
  deleteError: null,
  
  // Status update
  statusUpdateLoading: false,
  statusUpdateError: null,
  
  // Cities
  cities: [],
  citiesLoading: false,
  citiesError: null,
  
  // Initiators
  initiators: [],
  initiatorsLoading: false,
  initiatorsError: null,
  createInitiatorLoading: false,
  createInitiatorError: null,
  
  // File upload
  bannerUploadLoading: false,
  bannerUploadError: null,
  fileUploadLoading: false,
  fileUploadError: null,
  validateFileLoading: false,
  validateFileError: null,
  
  // Buttons
  buttons: [],
  buttonsLoading: false,
  buttonsError: null,
  createButtonLoading: false,
  createButtonError: null,
  
  // Success messages
  successMessage: null
};

export const companyPromotionsReducer = (state = initialState, action) => {
  switch (action.type) {
    // Get promotions list
    case COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTIONS_REQUEST:
      return {
        ...state,
        promotionsLoading: true,
        promotionsError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTIONS_SUCCESS:
      return {
        ...state,
        promotionsLoading: false,
        promotions: action.payload,
        promotionsError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTIONS_FAILURE:
      return {
        ...state,
        promotionsLoading: false,
        promotionsError: action.payload
      };
    
    // Get single promotion
    case COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTION_REQUEST:
      return {
        ...state,
        promotionLoading: true,
        promotionError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTION_SUCCESS:
      return {
        ...state,
        promotionLoading: false,
        currentPromotion: action.payload,
        promotionError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_PROMOTION_FAILURE:
      return {
        ...state,
        promotionLoading: false,
        promotionError: action.payload
      };
    
    // Create promotion
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_PROMOTION_REQUEST:
      return {
        ...state,
        createLoading: true,
        createError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_PROMOTION_SUCCESS:
      return {
        ...state,
        createLoading: false,
        createError: null,
        successMessage: 'Акция успешно создана'
      };
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_PROMOTION_FAILURE:
      return {
        ...state,
        createLoading: false,
        createError: action.payload
      };
    
    // Update promotion
    case COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_REQUEST:
      return {
        ...state,
        updateLoading: true,
        updateError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_SUCCESS:
      return {
        ...state,
        updateLoading: false,
        updateError: null,
        successMessage: 'Акция успешно обновлена'
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_FAILURE:
      return {
        ...state,
        updateLoading: false,
        updateError: action.payload
      };
    
    // Update promotion status
    case COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_STATUS_REQUEST:
      return {
        ...state,
        statusUpdateLoading: true,
        statusUpdateError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_STATUS_SUCCESS:
      return {
        ...state,
        statusUpdateLoading: false,
        statusUpdateError: null,
        successMessage: 'Статус акции успешно обновлен',
        promotions: state.promotions?.promotions ? {
          ...state.promotions,
          promotions: state.promotions.promotions.map(promotion => 
            promotion.id === action.payload.id 
              ? { ...promotion, status: action.payload.status }
              : promotion
          )
        } : state.promotions
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPDATE_PROMOTION_STATUS_FAILURE:
      return {
        ...state,
        statusUpdateLoading: false,
        statusUpdateError: action.payload
      };
    
    // Delete promotion
    case COMPANY_PROMOTIONS_ACTIONS.DELETE_PROMOTION_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        deleteError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.DELETE_PROMOTION_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        deleteError: null,
        promotions: state.promotions.filter(promotion => promotion.id !== action.payload),
        successMessage: 'Акция успешно удалена'
      };
    case COMPANY_PROMOTIONS_ACTIONS.DELETE_PROMOTION_FAILURE:
      return {
        ...state,
        deleteLoading: false,
        deleteError: action.payload
      };
    
    // Get cities
    case COMPANY_PROMOTIONS_ACTIONS.GET_CITIES_REQUEST:
      return {
        ...state,
        citiesLoading: true,
        citiesError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_CITIES_SUCCESS:
      return {
        ...state,
        citiesLoading: false,
        cities: action.payload,
        citiesError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_CITIES_FAILURE:
      return {
        ...state,
        citiesLoading: false,
        citiesError: action.payload
      };
    
    // Get initiators
    case COMPANY_PROMOTIONS_ACTIONS.GET_INITIATORS_REQUEST:
      return {
        ...state,
        initiatorsLoading: true,
        initiatorsError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_INITIATORS_SUCCESS:
      return {
        ...state,
        initiatorsLoading: false,
        initiators: action.payload,
        initiatorsError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_INITIATORS_FAILURE:
      return {
        ...state,
        initiatorsLoading: false,
        initiatorsError: action.payload
      };
    
    // Create initiator
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_INITIATOR_REQUEST:
      return {
        ...state,
        createInitiatorLoading: true,
        createInitiatorError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_INITIATOR_SUCCESS:
      return {
        ...state,
        createInitiatorLoading: false,
        createInitiatorError: null,
        successMessage: 'Инициатор успешно создан'
      };
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_INITIATOR_FAILURE:
      return {
        ...state,
        createInitiatorLoading: false,
        createInitiatorError: action.payload
      };
    
    // Upload banner
    case COMPANY_PROMOTIONS_ACTIONS.UPLOAD_BANNER_REQUEST:
      return {
        ...state,
        bannerUploadLoading: true,
        bannerUploadError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPLOAD_BANNER_SUCCESS:
      return {
        ...state,
        bannerUploadLoading: false,
        bannerUploadError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPLOAD_BANNER_FAILURE:
      return {
        ...state,
        bannerUploadLoading: false,
        bannerUploadError: action.payload
      };
    
    // Upload file
    case COMPANY_PROMOTIONS_ACTIONS.UPLOAD_FILE_REQUEST:
      return {
        ...state,
        fileUploadLoading: true,
        fileUploadError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPLOAD_FILE_SUCCESS:
      return {
        ...state,
        fileUploadLoading: false,
        fileUploadError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.UPLOAD_FILE_FAILURE:
      return {
        ...state,
        fileUploadLoading: false,
        fileUploadError: action.payload
      };
    
    // Validate file
    case COMPANY_PROMOTIONS_ACTIONS.VALIDATE_FILE_REQUEST:
      return {
        ...state,
        validateFileLoading: true,
        validateFileError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.VALIDATE_FILE_SUCCESS:
      return {
        ...state,
        validateFileLoading: false,
        validateFileError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.VALIDATE_FILE_FAILURE:
      return {
        ...state,
        validateFileLoading: false,
        validateFileError: action.payload
      };
    
    // Get buttons
    case COMPANY_PROMOTIONS_ACTIONS.GET_BUTTONS_REQUEST:
      return {
        ...state,
        buttonsLoading: true,
        buttonsError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_BUTTONS_SUCCESS:
      return {
        ...state,
        buttonsLoading: false,
        buttons: action.payload,
        buttonsError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.GET_BUTTONS_FAILURE:
      return {
        ...state,
        buttonsLoading: false,
        buttonsError: action.payload
      };
    
    // Create button
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_BUTTON_REQUEST:
      return {
        ...state,
        createButtonLoading: true,
        createButtonError: null
      };
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_BUTTON_SUCCESS:
      return {
        ...state,
        createButtonLoading: false,
        createButtonError: null,
        successMessage: 'Кнопка успешно создана'
      };
    case COMPANY_PROMOTIONS_ACTIONS.CREATE_BUTTON_FAILURE:
      return {
        ...state,
        createButtonLoading: false,
        createButtonError: action.payload
      };
    
    // Clear data
    case COMPANY_PROMOTIONS_ACTIONS.CLEAR_PROMOTION_DATA:
      return {
        ...state,
        currentPromotion: null,
        successMessage: null
      };
    
    case COMPANY_PROMOTIONS_ACTIONS.CLEAR_ERRORS:
      return {
        ...state,
        promotionsError: null,
        promotionError: null,
        createError: null,
        updateError: null,
        deleteError: null,
        statusUpdateError: null,
        citiesError: null,
        initiatorsError: null,
        createInitiatorError: null,
        bannerUploadError: null,
        fileUploadError: null,
        validateFileError: null,
        buttonsError: null,
        createButtonError: null
      };
    
    default:
      return state;
  }
};
